import React from "react";
import ResourceViewer from "./ResourceViewer";
import video from "../../public/media/videos/Video.mp4";


export default function MonitoringTutorial() {
  return (
    <ResourceViewer
      title="Crop Monitoring Tutorial"
      description="Learn how to monitor your crops and use crop intelligence tools."
      type="video"
      file={video}
    />
  );
}